import PageView from 'views/page/page-view';
import PageService from 'services/page-service';
import { SessionStorageService } from 'services/data-handler-services/web-storage-service';
import LocaleService from 'services/loader-handler-services/locale-service';
import Controller from 'controllers/base/controller';
import Chaplin from 'chaplin';
import utils from 'lib/utils';

export default Controller.extend({
  show: function (params, route, options) {
    if (params.module && utils.isNumeric(params.module.charAt(0))) {
      // eslint-disable-next-line no-console
      console.warn(
        'Module names cannot begin with a number. Rename the module such that the first character is not a number'
      );
    }
    PageService.loadPage(params.module, params.activity, params.page).then(page => {
      SessionStorageService.setItem('queryParams', options.query);
      if (PageService.preventSkippingPages(page, params)) {
        const linkedPage = page.get('link');
        const previouslyCompleted = page.get('completed') ? 'previously-completed' : '';
        const userSpecifiedClass = page.get('class') || '';
        const className = linkedPage
          ? `${linkedPage.page} ${linkedPage.activity} ${
              linkedPage.module
            } ${previouslyCompleted} ${userSpecifiedClass} ${LocaleService.getLanguage()}`
          : `${page.get('key')} ${page.get('activityKey')} ${page.get(
              'moduleKey'
            )} ${previouslyCompleted} ${userSpecifiedClass} ${LocaleService.getLanguage()}`;

        if (page.get('transition') && !page.get('transition-in')) {
          //console.log(`rendering ${page.get('key')} without transition-in; setting transition-in to ${page.get('transition-in')}`);
          page.set('transition-in', 'forward');
        }

        if (Object.isExtensible(this)) {
          this.view = new PageView({
            region: 'main',
            model: page,
            className: className,
          });

          //TODO: revisit trying to reuse the actionbarview, was moved to the page-view.play
          //this.reuse('actionbar', ActionBarView, {region: 'actionbar'});
          Chaplin.mediator.subscribeOnce('page:initialized', () => {
            this.view.play();
          });
        } else {
          return;
        }
      }
    });
  },
});
